/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid, InputLabel, TextField } from "@mui/material";
import { FC, Fragment, useState } from "react";
import { useFormik } from "formik";
import InputTextfield from "../../../../../shared/components/textField";
import { FormContainer } from "../../../../../shared/components/formContainer";
import useMutation from "../../../../../shared/components/hooks/useMutation";
import { getTextFields } from "../variables/textFields";
import SingleEntityImageViewer from "../../../../../shared/components/singleEntityImageViewer";
import ToggleSwitch from "../../../../../shared/components/switch";
import { customizeValidationSchema } from "../variables/customSchema";
import { ProfileBorderBox } from "../../../../../shared/components/profileComponents";

const IndustryCreate: FC = () => {
  const { loading: apiLoading, modifyData } = useMutation(
    "/master-datas/industries"
  );
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const textFields = getTextFields({}); //Get textboxes

  const initialValues = {
    name: "",
    iconURL: null,
    enabled: true,
  };
  const industryForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: customizeValidationSchema(),
    onSubmit: async (formData: any) => {
      const formDataIndustry = new FormData();
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      formDataIndustry.append("file", formData.iconURL);
      formDataIndustry.append("name", formData.name);
      formDataIndustry.append("enabled", formData.enabled ? "true" : "false");

      modifyData(`/industry`, "post", formDataIndustry, industryForm);
    },
  });

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      setPreviewUrl(URL.createObjectURL(file));
      industryForm.setFieldValue("iconURL", file);
    } else {
      setPreviewUrl(null);
      industryForm.setFieldValue("iconURL", null);
    }
  };

  const titleBar = {
    headerTitle: "Industry - Create",
    title: "Create Industry",
    buttonTitle: "Save",
    onClick: () => industryForm.handleSubmit(),
    dirty: industryForm.dirty,
    buttonLoading: apiLoading,
  };

  return (
    <>
      <ProfileBorderBox>
        <FormContainer titleBar={titleBar}>
          <Box className="border-custom">
            <Grid
              container
              alignItems="stretch"
              columnSpacing={4}
              rowSpacing={2}
            >
              <Grid item xs={12}>
                <ToggleSwitch
                  status={industryForm?.values?.enabled}
                  handleChange={() =>
                    industryForm.setFieldValue(
                      "enabled",
                      !industryForm?.values?.enabled
                    )
                  }
                />
              </Grid>

              {textFields.map((field: any, index: number) => (
                <Fragment key={field.id}>
                  {(field?.formField === undefined ||
                    field.formField === true) && (
                    <Grid item md={6} sm={6} xs={12}>
                      <InputTextfield
                        form={industryForm}
                        fieldProps={field}
                        key={index}
                      />
                    </Grid>
                  )}
                </Fragment>
              ))}
              <Grid item md={6} sm={6} xs={6} key="industry-iconURL">
                <InputLabel>Icon</InputLabel>
                <TextField
                  size="small"
                  fullWidth
                  id="outlined-basic"
                  type={"file"}
                  sx={{
                    marginTop: "1vh",
                    "& .MuiInputBase-root": {
                      height: "40px",
                      fontSize: "1rem",
                    },
                  }}
                  onChange={handleFileChange}
                />
              </Grid>
              <Grid item md={3} sm={6} xs={6} key="industry-iconPreview">
                <div>
                  <SingleEntityImageViewer src={previewUrl} alt="Event" />
                </div>
              </Grid>
            </Grid>
          </Box>
        </FormContainer>
      </ProfileBorderBox>
    </>
  );
};
export default IndustryCreate;
